@if(data?.footer?.footer_about){
<p>
  {{ data?.footer?.footer_about }}
</p>
}
